// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyCart_wrapper__LzuiJ","cart":"EmptyCart_cart__B8Ox8","closeImg":"EmptyCart_closeImg__WcrpC","header":"EmptyCart_header__mnSao"};